import { Button, Modal } from 'antd';
import { useCallback, useState } from 'react';
import { enTermsGenerationMoment } from '../../../enums/enTermsGenerationMoment';
import ExternalDocument from '../../ExternalDocument';
import { useForm } from '../context';
const ExternalDocumentModal = () => {
  const { checkout, forceSubmit, transaction, canSignDocument, setCanSignDocument, isDocumentSigned, setDocumentSigned } = useForm();
  const [hasError, setHasError] = useState(false);
  const hasExternalDocument = checkout?.hasExternalDocument && checkout.termsGenerationMoment == enTermsGenerationMoment.BEFORE;

  const shouldShow = hasExternalDocument && !isDocumentSigned && !!transaction?.id && canSignDocument;

  const handleDocumentSigned = useCallback(() => {
    console.log('Document signed');
    setDocumentSigned(true);
    setCanSignDocument(false);
    setTimeout(forceSubmit, 1000);
  }, [forceSubmit]);

  const handleDocumentError = () => {
    setHasError(true);
  };

  const handleTryAgain = () => {
    setCanSignDocument(false);
  };

  return (
    <Modal closable={false} destroyOnHidden open={shouldShow} footer={<>
      {hasError && <Button type='primary' onClick={handleTryAgain} className='w-full'>
        Tentar novamente
      </Button>}
    </>}>
      <ExternalDocument
        key="external-document-modal"
        teamId={checkout?.teamId!}
        transactionId={transaction?.id!}
        isSigned={isDocumentSigned}
        onDocumentSigned={handleDocumentSigned}
        onError={handleDocumentError}
      />
    </Modal>
  );
};

export default ExternalDocumentModal;
